
import { Placement } from '@post-office/placements-frontend/agent-studio-page-pre-content';
export default Placement;
